export default __webpack_public_path__ + "static/media/P-016.4de2fa94.png";